import Sheet from 'components/sheets/Sheet';
import React, { useMemo } from 'react';
import { useParkingStore } from 'stores/parkingStore';
import { isWeb } from 'utils/deviceUtils';
import ParkingZoneSearch from './ParkingZoneSearch';

export const snappingPointsWebMobile = (
  web: (string | number)[],
  mobile: (string | number)[]
): SnappingPointSet => {
  return { web, mobile };
};

export type SnappingPointSet = {
  web: (string | number)[];
  mobile: (string | number)[];
};

export const ParkingZoneSearchSheet: React.FC = () => {
  const ongoingSessionType = useParkingStore(
    (state) => state.selectedOngoingSession
  );
  const addMargin = ongoingSessionType !== '';
  const minifiedHeight = !addMargin ? '22.5%' : '32%';

  const snappingPoints = snappingPointsWebMobile(
    [430],
    [minifiedHeight, '45%', '95%']
  );

  const showBackDropIndex = useMemo(() => {
    return isWeb ? 0 : 2;
  }, []);

  return (
    <Sheet
      snappingPoints={snappingPoints[isWeb ? 'web' : 'mobile']}
      showBackDropIndex={showBackDropIndex}
      sheetMinHeight={220}>
      <ParkingZoneSearch />
    </Sheet>
  );
};

export default ParkingZoneSearchSheet;
